import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllowedFiltersThunk } from "../filters/thunks/getAllowedFiltersThunk";
import { getResourceExplorerVisibilityHierarchyThunk } from "../resource-explorer/thunks/resource-explorer-hierarchy-visibility/getResourceExplorerVisibilityHierarchyThunk";
import { getDashboardsVisibilityHierarchyThunk } from "../dashboards/thunks/dashboard-hierarchy-visibility/getDashboardsVisibilityHierarchyThunk";
import { getTaskAvailablePropertiesThunk } from "../task-management/thunks/properties/getTaskAvailablePropertiesThunk";
import { getResourceExplorerPossibleGroupingsThunk } from "@/store/resource-explorer/thunks/common/getResourceExplorerPossibleGroupingsThunk";
import { getAskAiChatIdThunk } from "@/store/ask-ai/thunks/getAskAiChatIdThunk";

interface InitializingApplicationThunkArgs {
  enableCategoryGroupingFilterV2: boolean;
}
export const initializingApplicationThunk = createAsyncThunk(
  "applicationCommon/applicationCommonThunk",
  async (
    { enableCategoryGroupingFilterV2 }: InitializingApplicationThunkArgs,
    { dispatch },
  ) => {
    await Promise.all([
      dispatch(getAllowedFiltersThunk()),
      dispatch(getTaskAvailablePropertiesThunk()),
      dispatch(getResourceExplorerVisibilityHierarchyThunk()),
      dispatch(getDashboardsVisibilityHierarchyThunk()),
      dispatch(
        getResourceExplorerPossibleGroupingsThunk({
          enableCategoryGroupingFilterV2,
        }),
      ),
      dispatch(getAskAiChatIdThunk()),
    ]);
  },
);
